<template>
  <div class="background">
    <div class="card opacity marginBottom">
      <mdb-row>
        <mdb-col class="pb-2">
          <h3 class="h3 py-2 text-center">Messages</h3>
        </mdb-col>
    </mdb-row>
    </div>
    <div class="opacity" v-for="contact in contacts" :key="contact.id">
      <mdb-row>
        <mdb-col class="pb-2">
          <mdb-card>
            <mdb-card-body>
              <mdb-card-text>
                <h5 class="h5 black-text">Name of the sender :</h5>
                  <span>
                    {{contact.name}}
                  </span><br>
                  <h5 class="h5 black-text">Email Adress :</h5>
                  <span>
                    {{contact.email}}
                  </span><br>
                  <h5 class="h5 black-text">Phone Number :</h5>
                  <span>
                    {{contact.phoneNumber}}
                  </span><br>
                  <h5 class="h5 black-text">Message / Enquiry :</h5>
                  <span>
                    {{contact.message}}
                  </span><br>
              </mdb-card-text>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
    </mdb-row>
    </div>
  </div>
</template>

<script>
import { contactsCollection } from '@/firebase'
import mdbRow from 'mdbvue/lib/components/mdbRow'
import mdbCol from 'mdbvue/lib/components/mdbCol'
import mdbCard from 'mdbvue/lib/components/mdbCard'
import mdbCardText from 'mdbvue/lib/components/mdbCardText'
import mdbCardBody from 'mdbvue/lib/components/mdbCardBody'

export default {
  components: {
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardText,
    mdbCardBody
  },
  data () {
    return {
      contacts: []
    }
  },
  firestore () {
    return {
      contacts: contactsCollection.orderBy('createdAt', 'desc')
    }
  }
}
</script>

<style scoped>
body, html {
  height: 100%;
}
.background{
background-image: url("~@/assets/message.svg");
background-repeat: no-repeat;
background-size: contain;
background-attachment: fixed;
background-position: center;
-webkit-background-size: contain;
-moz-background-size: contain;
-o-background-size: contain;
padding-bottom: 500px;
height: 100%;
}
.card {
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  transition: 0.3s;
}

.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
}
.opacity{
  opacity: 0.7;
}
.marginBottom{
  margin-bottom: 30px;
}
</style>
